"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Locale = void 0;
var Locale;
(function (Locale) {
    Locale["EN"] = "en";
    Locale["EN_GB"] = "en_GB";
    Locale["ES"] = "es";
    Locale["DE"] = "de";
    Locale["FR"] = "fr";
    Locale["IT"] = "it";
    Locale["PL"] = "pl";
    Locale["PT"] = "pt";
    Locale["SV"] = "sv";
    Locale["UK"] = "uk";
})(Locale = exports.Locale || (exports.Locale = {}));
;
//# sourceMappingURL=locale.js.map